import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { AddCompanySource } from './CompanySourceModal';
import { useAppContext } from '../../../Context/AppContext';
import CompanySourcesList from './CompanySourcesList';
import { ManageCompanySourceModal } from './ManageCompanySource/ManageCompanySourceModal';
import { getCompanySourcesMap } from './utils';
import './_CompanySourcesTab.scss';

const CompanySourcesTab = ({ companySources, setCompanySources }) => {
  const [companySourcesError, setCompanySourcesError] = useState();

  const { isInternalMode } = useAppContext();
  const resetCompanySources = () => setCompanySources();

  return (
    <div className="company-sources-tab" data-testid="company-sources-tab">
      {isInternalMode && (
        <div className="manage-sources-container">
          <AddCompanySource
            onSubmit={resetCompanySources}
            sourceMap={getCompanySourcesMap(companySources)}
          />

          <ManageCompanySourceModal
            companySources={companySources}
            onSubmit={resetCompanySources}
          />
        </div>
      )}

      <CompanySourcesList
        companySources={companySources}
        errorMessage={companySourcesError}
        setCompanySources={setCompanySources}
        setErrorMessage={setCompanySourcesError}
      />
    </div>
  );
};

export default CompanySourcesTab;

CompanySourcesTab.propTypes = {
  companySources: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
      companyMarketingSourceId: PropTypes.number,
      leasingTeamEnabledCount: PropTypes.number,
      id: PropTypes.number,
      isDefault: PropTypes.bool,
      isEnabled: PropTypes.bool,
      name: PropTypes.string,
    })
  ),
  setCompanySources: PropTypes.func,
};
